// Inline spinning loader. The CSS keyframes for `spin` live in
// frontend/index.html so any size/color works without a stylesheet
// import.

import React from "react";
import { C } from "../constants.js";

export function Spinner({ size = 20, color = C.gold }) {
  return React.createElement("svg", {width:size,height:size,viewBox:"0 0 24 24",fill:"none",style:{animation:"spin 1s linear infinite"}},
    React.createElement("circle",{cx:12,cy:12,r:10,stroke:color,strokeWidth:3,opacity:0.25}),
    React.createElement("path",{d:"M12 2a10 10 0 0 1 10 10",stroke:color,strokeWidth:3,strokeLinecap:"round"})
  );
}
